import { Observable } from 'rxjs';

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '@env/environment';

const base_url = environment.BASE_URL;

@Injectable({
  providedIn: 'root',
})
export class CompanyHttpService {
  constructor(private httpClient: HttpClient) {}

  public fetch(): Observable<any> {
    return this.httpClient.get(`${base_url}api/company-detail`);
  }

  public update(data): Observable<any> {
    return this.httpClient.post(`${base_url}api/company-settings`, data);
  }
}
